var _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.577 22.369H7.753C4.312 22.369 2 19.954 2 16.359V8.047c0-3.594 2.312-6.01 5.753-6.01h3.739a.75.75 0 0 1 0 1.5H7.753c-2.584 0-4.253 1.77-4.253 4.51v8.314c0 2.739 1.669 4.509 4.253 4.509h8.824c2.584 0 4.254-1.77 4.254-4.51v-4.027a.75.75 0 0 1 1.5 0v4.028c0 3.594-2.313 6.009-5.754 6.009Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22.083 6.163H14.75a.75.75 0 1 1 0-1.5h7.333a.75.75 0 0 1 0 1.5Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.416 9.827a.75.75 0 0 1-.75-.75V1.75a.75.75 0 0 1 1.5 0v7.327a.75.75 0 0 1-.75.75ZM10.107 12.66a.467.467 0 0 1-.467-.466c0-.258.206-.466.463-.466h.004a.465.465 0 1 1 0 .931ZM11.973 12.66a.467.467 0 0 1-.467-.466c0-.258.205-.466.463-.466h.004a.465.465 0 1 1 0 .931ZM13.838 12.66a.467.467 0 0 1-.467-.466c0-.258.206-.466.463-.466h.004a.465.465 0 1 1 0 .931Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 10,
    height: 11,
    x: 7,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 7h10v10H7V7Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.377 15.689c.27 0 .525.102.794.21a4.332 4.332 0 0 0 4.874-.855 4.31 4.31 0 0 0 0-6.087 4.274 4.274 0 0 0-3.043-1.26c-1.15 0-2.232.448-3.044 1.26a4.324 4.324 0 0 0-.862 4.858c.11.27.214.532.214.805 0 .272-.093.546-.176.788-.068.199-.17.5-.104.566.064.067.367-.039.566-.107.24-.082.512-.176.781-.178ZM11.99 17c-.711 0-1.427-.15-2.096-.46-.198-.079-.382-.153-.515-.153-.152 0-.358.071-.556.14-.407.14-.913.313-1.287-.06-.373-.373-.201-.878-.063-1.284.069-.2.139-.407.139-.563 0-.129-.062-.292-.157-.528a5.017 5.017 0 0 1 1.01-5.628A4.966 4.966 0 0 1 12 7c1.337 0 2.593.52 3.536 1.464a5.008 5.008 0 0 1 0 7.074A5.017 5.017 0 0 1 11.99 17Z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribe);
export default __webpack_public_path__ + "static/media/Subscribe.9bd9df975631110baa7744ebfa57ed58.svg";
export { ForwardRef as ReactComponent };